import { useTranslation } from "react-i18next";
import { Button, Col, Row } from "antd";
import { Typography } from "antd";
import React from "react";

const { Text } = Typography;
interface SelectAllPropsTypes {
  handleOnClickSelectAll: () => void;
  handleOnClickReset: () => void;
  totalRowsSelected: number;
  totalRows: number;
}

export default function SelectAll(props: SelectAllPropsTypes): React.ReactElement {
  const { totalRowsSelected, totalRows, handleOnClickSelectAll, handleOnClickReset } = props;
  const { t } = useTranslation();

  const showSelectAll = totalRowsSelected > 1;
  const showClearButton = totalRowsSelected === totalRows;

  return (
    <>
      {showSelectAll && (
        <Row gutter={[24, 0]} className="select-all__top-bar">
          <Col span={12}>
            <Row justify="end">
              <Col>
                <Text type="secondary">
                  {t("total_rows_selected_prefix")} <strong>{totalRowsSelected}</strong>{" "}
                  {t("total_rows_selected_suffix")}
                </Text>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row justify="start">
              <Button
                onClick={showClearButton ? handleOnClickReset : handleOnClickSelectAll}
                type="default"
              >
                {showClearButton ? (
                  t("Clear selection")
                ) : (
                  <span className="select-all-button">
                    {t("select_all_rows_prefix")} <strong>{totalRows}</strong>{" "}
                    {t("select_all_rows_suffix")}
                  </span>
                )}
              </Button>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
}
